<template>
  <div class="privacy">
    <p class="title">{{$lang('隐私政策')}}</p>
    <p class="title-sub">المقدمة</p>
    <p class="indent"> تنطبق هذه السياسة على المنتجات والخدمات التي تقدمها شركة Shanghai Jitu Express Co.، Ltd. والشركات التابعة لها وشركاء الامتياز المعتمدين لشركة Jitu (يشار إليهم فيما بعد باسم "Jitu" أو "نحن"). / أو الخدمة. لقد أولينا دائمًا أهمية كبيرة لخصوصية المستخدم وحماية المعلومات الشخصية. عندما تستخدم منتجاتنا و / أو خدماتنا ، يجوز لنا جمع واستخدام المعلومات ذات الصلة الخاصة بك. قبل استخدام منتجاتنا و / أو خدماتنا ، يرجى القراءة بعناية والتأكيد على أنك قد فهمت محتوى هذه السياسة تمامًا ، وخاصة الشروط الجريئة. عند استخدام منتجاتنا و / أو خدماتنا ، أو الاستمرار في استخدامها بعد تحديث هذه السياسة ، يُعتبر أنك قد قرأت وفهمت ووافقت على هذه السياسة ونسختها المحدثة. إذا كنت لا توافق على أي من شروط هذه السياسة ، فيحق لك التوقف فورًا عن استخدام منتجاتنا و / أو خدماتنا. </p>
    <p class="text-bold"> ستساعدك هذه السياسة على فهم ما يلي: </p>
    <p class="text-bold"> 1. كيف نجمع معلوماتك الشخصية ونستخدمها </p>
    <p class="text-bold"> ثانيًا. كيف نستخدم ملفات تعريف الارتباط والتقنيات المماثلة </p>
    <p class="text-bold"> ثالثًا. كيف نشارك معلوماتك الشخصية وننقلها ونكشف عنها علنًا </p>
    <p class="text-bold"> 4. كيف نحمي معلوماتك الشخصية ونحفظها </p>
    <p class="text-bold"> 5. حقوقك </p>
    <p class="text-bold"> سادسا. حماية معلومات القاصرين </p>
    <p class="text-bold"> سبعة. كيفية نقل معلوماتك الشخصية عالميًا </p>
    <p class="text-bold"> ثمانية ، إشعار ومراجعة </p>
    <p class="text-bold"> تسعة. كيفية الاتصال بنا </p>

    <p class="text-bold"> 1. كيف نجمع معلوماتك الشخصية ونستخدمها </p>
    تشير <p> <span class="text-bold"> المعلومات الشخصية </span> إلى معلومات متنوعة مسجلة إلكترونيًا أو بطرق أخرى يمكنها تحديد شخص طبيعي معين بمفرده أو بالاشتراك مع معلومات أخرى أو تعكس أنشطة شخص معين شخص طبيعي. </p>
    <p> <span class="text-bold"> المعلومات الشخصية الحساسة </span> تعني أنه بمجرد تسريبها أو تقديمها بشكل غير قانوني أو إساءة استخدامها ، فقد تعرض السلامة الشخصية وسلامة الممتلكات للخطر ، وتؤدي بسهولة إلى السمعة الشخصية والصحة البدنية والعقلية الضرر أو المعاملة التمييزية وغيرها من المعلومات الشخصية. سيتم تمييز المعلومات الحساسة الشخصية التي تتضمنها هذه السياسة بخط عريض. </p>
    <p> لن تجمع Jitu معلوماتك الشخصية وتستخدمها إلا للأغراض التالية الموضحة في هذه السياسة: </p>

    <p class="text-bold"> (1) جمع واستخدام معلوماتك الشخصية من خلال وظائف العمل الأساسية </p>
    <p class="text-bold"> يجوز لنا جمع وحفظ واستخدام المعلومات التالية عنك من أجل تحقيق الوظائف الموضحة أدناه. إذا لم تقدم المعلومات ذات الصلة ، فلن تتمكن من الاستمتاع بخدمة Polar Rabbit ذات الصلة. تتضمن هذه الميزات: </p>
    <p class="text-bold"> 1. تسجيل حساب </p>
    <p> لإكمال إنشاء الحساب ، يلزمك تقديم المعلومات التالية (يشار إليها إجمالاً باسم "معلومات الحساب"): <span class="text-bold"> رقم هاتفك المحمول </span> ، <span class="text-bold"> اسم الحساب </span> / nickname ، <span class="text-bold"> كلمة مرور الحساب </span> ، سنتحقق من هويتك عن طريق إرسال رمز التحقق عبر الرسائل القصيرة ؛ ويمكنك أيضًا إضافة المعلومات الشخصية ، ستساعدنا معلوماتك التكميلية على تزويدك بتجربة خدمة مخصصة لك. إذا لم تقدم هذه المعلومات التكميلية ، فلن تؤثر على الوظائف الأساسية لخدمتك. </p>
    <p class="text-bold">2. تزويدك بخدمات التوصيل</p>
    <p> عندما تقدم طلبًا للشحن أو عندما يتم تقديم معلوماتك كمستلم ، ستجمع Jitu أو شريكها التجاري المعتمد المعلومات التالية عنك: اسم وعنوان المرسل والمستلم ، <span class=" text-bold "> معلومات الاتصال </span> ومعلومات البريد السريع (يشار إليها مجتمعة باسم" معلومات وجهاً لوجه ") لتقديم الطلبات ، والاستلام ، والفرز ، والتخزين ، والنقل ، والتخليص الجمركي للتصدير ، والتخليص الجمركي للاستيراد ، و التسليم ؛ وفقًا للمتطلبات القانونية ذات الصلة ، نجمع أيضًا <span class="text-bold"> معلومات بطاقة الهوية </span> للتحقق من هويتك وإقرارات الاستيراد والتصدير. </p>

    <p class="text-bold">3. الدفع والتسوية</p>
    <p> بعد تقديم طلب ، يمكنك اختيار خدمات الدفع التي تقدمها مؤسسات الدفع التابعة لجهة خارجية (مثل Alipay و WeChat Pay و UnionPay و Net Union وما إلى ذلك ، والمشار إليها فيما يلي باسم "مؤسسات الدفع") التي تتعاون مع Jitu. يلزمك تقديم رقم طلب Jitu و <span class="text-bold"> معلومات مبلغ المعاملة </span> لمؤسسات الدفع هذه لتأكيد تعليمات الدفع وإكمال الدفع. </p>
    <p> إذا تقدمت بطلب للحصول على فاتورة ، فستحتاج أيضًا إلى تقديم المعلومات التالية: رأس الفاتورة ، ورقم تعريف دافع الضرائب ، و <span class="text-bold"> عنوان البريد الإلكتروني للمستلم </span> ، وأنت تقدمه وفقًا لـ تحتاج الفواتير الخاصة بك إلى مزيد من المعلومات ، مثل معلومات المشتري. </p>

    <p class="text-bold">4. دفع الأخبار</p>
    <p>نجمع معلومات جهازك ونستخدمها لدفع معلومات توجيه البريد السريع ومعلومات حالة الدفع والقسائم والمعلومات الترويجية. يمكنك ضبط إعداد DND في "إعدادات" هاتفك المحمول أو الأجهزة الأخرى ، أو في التطبيق ، حساب WeChat الرسمي ، إلخ.</p>

    <p class="text-bold"> 5. خدمة العملاء وخدمة ما بعد البيع </p>
    <p> ستستخدم خدمة العملاء ووظائف ما بعد البيع معلومات حسابك والمعلومات وجهًا لوجه. </p>
    <p> لضمان أمان حسابك ، ستستخدم خدمة العملاء في مركز الاتصال وخدمة العملاء عبر الإنترنت <span class="text-bold"> معلومات حسابك </span> للتحقق من هويتك. عندما تحتاج إلينا لتقديم خدمة العملاء وخدمة ما بعد البيع المتعلقة بشحنتك ، فسوف نستفسر عن <span class="text-bold"> معلوماتك وجهًا لوجه </span> ومعلومات توجيه البريد السريع. يمكنك تقديم معلومات أخرى غير المعلومات المذكورة أعلاه عند الاتصال بموظفي خدمة العملاء لدينا ، مثل عندما تطلب منا تغيير عنوان التسليم أو جهة الاتصال أو <span class="text-bold"> رقم الاتصال </span>. </p>

    <p class="text-bold">6、改善我们的产品或服务</p>
    <p><span class="text-bold">我们可能会将收集的您的账户信息、面单信息进行数据分析，从而为您提供个性化服务。</span>对于从您的各种设备上收集到的信息，我们可能会将它们进行关联，以便我们能在这些设备上为你提供一致的服务。我们可能会将来自某项服务的信息与来自其他服务的信息、合法间接获取的信息及合法公开渠道获取的信息结合，或者将合法获取的您的可识别个人信息与无法识别个人的信息结合，为您提供个性化服务及改善我们的产品和服务。</p>

    <p class="text-bold">7、保障交易安全</p>
    <p>为提高您使用我们的服务时系统的安全性，更准确地预防钓鱼网站欺诈和保护账户安全，我们可能会通过了解您的<span class="text-bold">浏览信息、面单信息、</span>您常用的软件信息、设备信息等手段来判断您的账号风险，并可能会记录一些我们认为有风险的链接（“URL”）；我们也会收集您的设备信息对于极兔系统问题进行分析、统计流量并排查可能存在的风险、在您选择向我们发送异常信息时予以排查。</p>

    <p class="text-bold">（二）附加业务功能收集和使用您个人信息的情形</p>
    <p>为使您更便捷地使用极兔的产品与/或服务，我们的以下附加功能可能会收集和使用您的个人信息。如果您不提供这些信息，您依然可以使用极兔的服务，但您可能无法使用这些可以为您带来便捷的附加功能或者需要重复填写一些信息。这些附加功能包括：</p>

    <p class="text-bold">1、语音输入</p>
    <p>您可以直接使用麦克风来进行语音输入<span class="text-bold">面单信息</span>或与我们的客服机器人进行咨询和互动。在这些功能中我们会收集您的录音内容以识别您的寄件需求和客服与售后需求。</p>

    <p class="text-bold">2、地图功能</p>
    <p>您可使用该功能查询极兔服务点，并使用导航功能。如您使用该功能，我们需要收集您的<span class="text-bold">地理位置信息</span>。</p>

    <p class="text-bold">3、基于摄像头（相机）的附加功能</p>
    <p>您可以使用这个附加功能完成扫码寄件、扫码支付功能。</p>

    <p class="text-bold">4、基于通讯录信息的附加功能</p>
    <p>您可以选择调用您的<span class="text-bold">通讯录信息</span>以方便您在填写面单信息时不再手动输入您通讯录中联系人的信息。</p>
    <p>上述附加功能可能需要您在您的设备中向我们开启您的地理位置（位置信息）、相机（摄像头）、相册（图片库）、麦克风以及通讯录的访问权限，以实现这些功能所涉及的信息的收集和使用。您可以在手机等设备的“设置”中逐项查看上述权限的开启状态，并可以决定将这些权限随时开启或关闭。<span class="text-bold">您开启这些权限即代表您授权我们可以收集和使用这些个人信息来实现上述功能；如您关闭权限，我们将不再继续收集和使用您的这些个人信息，也无法为您提供上述与这些授权所对应的功能。您关闭权限不会影响此前基于您的授权所进行的个人信息的处理。</span></p>

    <p class="text-bold">（三）间接获取、使用个人信息的情形</p>
    <p>1、我们可能从第三方获取您授权共享的<span class="text-bold">账户信息</span>（头像、昵称），并在您同意本政策后将您的第三方账户与您的极兔账户绑定，使您可以通过第三方账户直接登录并使用极兔的服务。</p>
    <p>2、如您通过非极兔页面的第三方渠道下单寄件，极兔将从这些第三方渠道获取您的面单信息，包括收寄件人姓名、<span class="text-bold">电话</span>、地址和快件信息，以便为您提供收寄件相关服务。</p>
    <p>3、如我们从我们的合作伙伴获取您的个人信息，我们将依据与第三方的约定、对个人信息来源的合法性进行确认后，在符合相关法律和法规规定的前提下，使用您的这些个人信息。</p>

    <p class="text-bold">（四）其他用途</p>
    <p>1、我们通过技术手段对收集的您的个人信息进行去标识化处理后，去标识化处理的信息将无法识别主体，您知悉并同意，<span class="text-bold">我们有权使用已经去标识化的信息。在不透露您个人信息的前提下，我们有权对用户数据库进行分析并予以商业化的利用。</span></p>
    <p>2、我们会对我们服务使用情况进行统计，并可能会与公众或第三方共享这些统计信息，以展示我们的服务的整体使用趋势。但这些统计信息不包含您的任何身份识别信息。</p>
    <p>3、当我们展示您的个人信息时，我们会采用包括内容替换、匿名处理方式对您的信息进行脱敏，以保护您的信息安全。</p>
    <p>4、当我们要将您的个人信息用于本政策未载明的其它用途时，或基于特定目的收集而来的信息用于其他目的时，会通过合理形式事先征求您的同意。</p>

    <p class="text-bold">（五）征得同意的例外</p>
    <p>1、您充分知悉，在以下情形中，我们收集、使用个人信息无须征得您的授权同意：</p>
    <p>（1）与国家安全、国防安全有关的；</p>
    <p>（2）与公共安全、公共卫生、重大公共利益有关的；</p>
    <p>（3）与犯罪侦查、起诉、审判和判决执行等有关的；</p>
    <p>（4）出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</p>
    <p>（5）所收集的个人信息是个人信息主体自行向社会公众公开的；</p>
    <p>（6）从合法公开披露的信息中收集的您的个人信息的，如合法的新闻报道、政府信息公开等渠道；</p>
    <p>（7）根据您的要求签订和履行合同所必需的；</p>
    <p>（8）用于维护所提供的服务的安全稳定运行所必需的，例如发现、处置服务的故障；</p>
    <p>（9）为合法的新闻报道所必需的；</p>
    <p>（10）法律法规规定的其他情形。</p>
    <p>2、根据法律规定，共享、转让经去标识化处理的个人信息，且确保数据接收方无法复原并重新识别个人信息主体的，不属于个人信息的对外共享、转让及公开披露行为，对此类数据的保存及处理将无需另行向您通知并征得您的同意。</p>

    <p class="text-bold">二、我们如何使用Cookie和同类技术</p>
    <p>（一）Cookie</p>
    <p>为确保网站正常运转，我们会在您的计算机或移动设备上存储名为Cookie的小数据文件。Cookie通常包含标识符、站点名称以及一些号码和字符。借助于Cookie，网站能够存储您的偏好等数据。极兔启用Cookie的目的与大多数网站或互联网服务提供商启用 Cookie 的目的一样，即改善用户体验。借助于 Cookie，网站能够记住用户的单次访问（使用会话 Cookie）或多次访问（使用永久 Cookie）。借助于 Cookie，网站能够保存设置，例如计算机或移动设备的语言、字体大小和其他浏览偏好。这意味着，用户无需在每次访问时重新配置用户偏好设置。如果某个网站不使用 Cookie，那么在用户每一次打开网页时，该网站都会将其视为新访客。例如，如果您登录某个网站后转到另一个网页，该网站就不会识别出您，而您会被再次注销。 极兔不会将 Cookie 用于本政策所述目的之外的任何用途。您可根据自己的偏好管理或删除 Cookie。有关详情，请参见 AboutCookies.org。您可以清除计算机上保存的所有 Cookie，大部分网络浏览器都设有阻止 Cookie 的功能。但如果您这么做，则需要在每一次访问我们的网站时亲自更改用户设置。如需详细了解如何更改浏览器设置，请访问以下链接：</p>
    <p>Internet Explorer：</p>
    <p>https://support.microsoft.com/zh-cn/help/260971/description-of-cookies</p>
    <p>Google Chrome：</p>
    <p>https://support.google.com/chrome/answer/95647?hl=en-GB&p=cpn_cookies</p>
    <p>Mozilla Firefox：</p>
    <p>https://support.mozilla.org/en-US/kb/cookies-information-websites-store-on-your-computer?redirectlocale=en-US&redirectslug=Cookies</p>
    <p>Safari：https://support.apple.com/kb/PH5042?locale=zh_CN</p>

    <p class="text-bold">（二）网站信标和像素标签</p>
    <p>除 Cookie 外，我们还会在网站上使用网站信标和像素标签等其他同类技术。例如，极兔速递向您发送的电子邮件可能含有链接至极兔速递网站内容的点击 URL。如果您点击该链接，极兔速递则会跟踪此次点击，帮助我们了解您的产品和服务偏好并改善客户服务。网站信标通常是一种嵌入到网站或电子邮件中的透明图像。借助于电子邮件中的像素标签，我们能够获知电子邮件是否被打开。如果您不希望自己的活动以这种方式被追踪，则可以随时从极兔速递的寄信名单中退订。</p>
    <p>您使用我们的网站意味着您同意按照如上所述使用Cookie，网站信标和像素标签。</p>
    <p class="text-bold">Do Not Track（请勿追踪）</p>
    <p>很多网络浏览器均设有Do Not Track功能，该功能可向网站发布Do Not Track请求。目前，主要互联网标准组织尚未设立相关政策来规定网站应如何应对此类请求。但如果您的浏览器启用了Do Not Track，那么我们的所有网站都会尊重您的选择。</p>

    <p class="text-bold">三、我们如何共享、转让、公开披露您的个人信息</p>
    <p class="text-bold">（一）共享</p>
    <p>1、我们不会与极兔的任何公司、组织和个人分享您的个人信息，但以下情况除外：</p>
    <p>（1）在获取明确同意的情况下共享：获得您的明确同意后，我们会与其他方共享您的个人信息；</p>
    <p>（2）我们可能会根据法律法规规定，或按政府主管部门的强制性要求，对外共享您的个人信息；</p>
    <p>（3）在法律法规允许的范围内，为维护极兔或合作伙伴、您或其他极兔用户或社会公众利益、财产或安全免遭损害而有必要提供；</p>
    <p>（4）只有共享您的信息，才能实现我们的服务的核心功能或提供您需要的服务；</p>
    <p>（5）应您需求为您处理您与他人的纠纷或争议；</p>
    <p>（6）符合与您签署的相关协议（包括在线签署的电子快递服务协议）或其他的法律文件约定所提供；</p>
    <p>（7）基于学术研究而使用；</p>
    <p>（8）基于符合法律法规的社会公共利益而使用。</p>

    <p>2、与我们的关联公司共享：您的个人信息可能会与极兔的关联公司共享。我们只会共享必要的个人信息，且受本政策中所声明目的的约束。关联公司如要改变个人信息的处理目的，将再次征求您的授权同意。</p>

    <p>3、与授权合作伙伴共享：仅为实现本政策中声明的目的，我们的某些服务将由授权合作伙伴提供。我们可能会与合作伙伴共享您的某些个人信息，以提供更好的客户服务和用户体验。例如，我们为您提供清关服务时，我们可能与清关服务提供商共享您的个人信息以安排合作伙伴提供服务。我们只会共享提供服务所必要的个人信息，我们的合作伙伴无权将共享的个人信息用于任何其他用途。</p>

    <p class="text-bold">（二）转让</p>
    <p>我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：</p>
    <p>1、在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息；</p>
    <p>2、在涉及合并、收购或破产清算时，如涉及到个人信息转让，我们会在要求新的持有您个人信息的公司、组织继续受本政策的约束，否则我们将要求该公司、组织重新向您征求授权同意。</p>
    <p>3、符合与您签署的相关协议（包括在线签署的电子快递服务协议）或其他的法律文件约定所提供；</p>
    <p>4、根据适用的法律法规、法律程序的要求、强制性的行政或司法要求所必须的情况进行提供。</p>

    <p class="text-bold">（三）公开披露</p>
    <p>我们仅会在以下情况下，公开披露您的个人信息</p>
    <p>1、获得您明确同意后；</p>
    <p>2、基于法律的披露：在法律、法律程序、诉讼或政府主管部门强制性要求的情况下，我们可能会公开披露您的个人信息。</p>

    <p class="text-bold">四、我们如何保护和保存您的个人信息</p>
    <p class="text-bold">（一）我们如何保护您的个人信息安全</p>
    <p>1、我们已采取符合业界标准、合理可行的安全防护措施保护您提供的个人信息安全，防止个人信息遭到未经授权访问、公开披露、使用、修改、损坏或丢失。我们会使用加密技术提高个人信息的安全性；我们会使用受信赖的保护机制防止个人信息遭到恶意攻击；我们会部署访问控制机制，尽力确保只有授权人员才可访问个人信息；以及我们会举办安全和隐私保护培训课程，加强员工对于保护个人信息重要性的认识；</p>
    <p>2、我们会采取合理可行的措施，尽力避免收集无关的个人信息。我们只会在达成本政策所述目的所需的期限内保留您的个人信息，除非需要延长保留期或受到法律的允许。</p>
    <p>3、互联网并非绝对安全的环境，我们强烈建议您不要使用非极兔推荐的通信方式发送个人信息。您可以通过我们的服务建立联系和相互分享。当您通过我们的服务创建交流、交易或分享时，您可以自主选择沟通、交易或分享的对象，作为能够看到您的交易内容、联络方式、交流信息或分享内容等相关信息的第三方。在使用极兔服务进行网上交易时，您不可避免地要向交易对方或潜在的交易对方披露自己的个人信息，如联络方式或联系地址。请您妥善保护自己的个人信息，仅在必要的情形下向他人提供。请注意，您在使用我们服务时自愿共享甚至公开分享的信息，可能会涉及您或他人的个人信息甚至个人敏感信息。请您更加谨慎地考虑，是否在使用我们的服务时共享甚至公开分享相关信息。请使用复杂密码，协助我们保证您的账号安全。我们将尽力保障您发送给我们的任何信息的安全性。如果我们的物理、技术或管理防护设施遭到破坏，导致信息被非授权访问、公开披露、篡改或毁坏，导致您的合法权益受损，我们将承担相应的法律责任。</p>
    <p>4、在不幸发生个人信息安全事件后，我们将按照法律法规的要求向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。事件相关情况我们将以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，上报个人信息安全事件的处置情况。</p>

    <p class="text-bold">（二）个人信息的保存期限</p>
    <p>1、为满足您的查询需要，<span class="bg-yellow">您的面单信息在极兔快递前台系统将保留三个月</span>，您可通过面单上标明的寄件人、收件人手机号或单号在极兔快递官网查询快件路由信息，满足该期限后，我们将在极兔快递前台系统中删除您的面单信息，使其保持不可被检索、访问的状态。</p>
    <p>2、您的个人信息将在极兔快递后台系统保存更长的期限，具体期限根据个人信息的类型、法律法规要求和满足本政策所述目的确定。</p>
    <p>3、如果我们终止服务或运营，我们会提前向您通知，并在终止服务或运营后对您的个人信息进行删除或匿名化处理。</p>

    <p class="text-bold">五、您的权利</p>
    <p>按照中国相关的法律、法规、标准，以及其他国家、地区的通行做法，我们保障您对自己的个人信息行使以下权利：</p>
    <p class="text-bold">（一）访问您的个人信息</p>
    <p>1、您有权访问您的个人信息，法律法规规定的例外情况除外。如果您想行使数据访问权，可以通过以下方式自行访问：</p>
    <p>（1）账户信息--如果您希望访问或编辑您的账户中的个人资料信息，您可以使用您在极兔的账号和密码登录您所注册的极兔相关网站、APP、微信公众号等查询您注册时向极兔提供的个人信息。</p>
    <p>（2）寄件记录--您可以使用您在极兔的账号和密码登录您所注册的极兔相关网站、APP、微信公众号等查看您的此类信息。</p>
    <p>（3）寄件、收件信息--你可以使用您在极兔的账号和密码登录您所注册的极兔相关网站、APP、微信公众号等，新建、修改、删除您的寄件地址及常用收件地址（部分渠道不支持该功能）。</p>
    <p>2、如您需要访问您在使用我们的产品与/或服务过程中产生的其他个人信息，您可以与我们联系，我们会根据本政策所列明的方式和期限响应您的请求。</p>

    <p class="text-bold">（二）更正您的个人信息</p>
    <p>当您发现我们处理的关于您的个人信息有错误时，您有权要求我们做出更正。您可以通过“（一）访问您的个人信息”中罗列的方式更正您的个人信息。</p>
    <p>如您需要更正您在使用我们的产品或服务过程中产生的其他个人信息，如修改派送地址、<span>联系电话</span>，您可以与我们的客服联系。</p>

    <p class="text-bold">（三）删除您的个人信息</p>
    <p>1、在以下情形中，您可以向我们提出删除个人信息的请求：</p>
    <p>（1）如果我们处理个人信息的行为违反法律法规；</p>
    <p>（2）如果我们处理个人信息的行为违反了与您的约定；</p>
    <p>（3）如果您不再使用我们的产品与/或服务，或您注销了账号；</p>
    <p>（4）如果我们不再为您提供产品或服务；</p>
    <p>2、当您从我们的服务中删除信息后，我们可能不会立即备份系统中删除相应的信息，但会在备份更新时删除这些信息。</p>

    <p class="text-bold">（四）改变您授权同意的范围</p>
    <p>1、每个业务功能需要一些基本的个人信息才能得以完成（见本政策“第一部分”）。对于额外收集的个人信息的收集和使用，您可以随时给予或收回您的授权同意。您可以通过删除信息、关闭设备功能、在极兔网站、App、微信公众号等进行隐私设置、在您的设备中设置或关闭相关权限（见本政策“第一部分”-“（二）附加业务功能收集和使用您个人信息的情形”）改变您授权我们继续收集个人信息的范围或撤回您的授权。您也可以通过注销账户的方式，撤回我们继续收集您个人信息的全部授权。</p>
    <p>2、当您收回同意后，我们将不再处理相应的个人信息。但您收回同意的决定，不会影响此前基于您的授权而开展的个人信息处理。</p>
    <p>3、如果您不想接受我们给您发送的商业广告，您随时可通过以下方式取消：</p>
    <p class="text-bold">无论您基于何种原因拒绝接收相关信息，您可以在收到营销信息时，根据信息中的退订提示（如“回复TD退订”），要求极兔不再向您发送营销信息，极兔会尊重您的请求。</p>

    <p class="text-bold">（五）响应您的上述请求</p>
    <p>1、为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的请求。<span class="bg-yellow">我们将在三十天内做出答复</span> 。</p>
    <p>2、对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情收取一定成本费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际的请求，我们可能会予以拒绝。在以下情形中，按照法律法规要求，我们将无法响应您的请求：</p>
    <p>（1）与国家安全、国防安全直接相关的；</p>
    <p>（2）与公共安全、公共卫生、重大公共利益直接相关的；</p>
    <p>（3）与犯罪侦查、起诉、审判和判决执行等直接相关的；</p>
    <p>（4）有充分证据表明您存在主观恶意或滥用权利的；</p>
    <p>（5）响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的。</p>
    <p>（6）涉及商业秘密的。</p>

    <p class="text-bold">六、未成年人信息的保护</p>
    <p>1、极兔非常重视对未成年人个人信息的保护。若您是18周岁以下的未成年人，在使用我们的产品与/或服务前，应事先取得您家长或法定监护人的书面同意。极兔根据国家相关法律法规的规定保护未成年人的个人信息。</p>
    <p>2、对于经父母或法定监护人同意而收集未成年人个人信息的情况，我们只会在受到法律允许、父母或监护人明确同意或者保护未成年人所必要的情况下使用或公开披露此信息。</p>
    <p>3、如果我们发现自己在未事先获得可证实的父母或法定监护人同意的情况下收集了未成年人的个人信息，则会设法尽快删除相关数据。</p>

    <p class="text-bold">七、您的个人信息如何在全球范围转移</p>
    <p>1、我们在中华人民共和国境内运营中收集和产生的个人信息，存储在中国境内。<span class="text-bold">如您选择极兔的国际&港澳台业务，您明确知晓您的个人信息将被传输到原始收集国/地区以外的国家/地区</span>。极兔国际件采取合作伙伴代理模式，我们通过系统对接的方式，将国际件<span class="text-bold">面单信息</span> 传输给原始收集国/地区以外的国家/地区的关联公司、合作伙伴。</p>
    <p>2、此类国家/地区可能设有不同的数据保护法，甚至未设立相关法律。在此类情况下，我们会确保您的个人信息得到在原始收集国/地区境内足够同等的保护。</p>

    <p class="text-bold">八、通知和修订</p>
    <p>1、为给您提供更好的服务以及随着极兔业务的发展，本隐私政策也会随之更新。但未经您明确同意，我们不会削减您按照本政策所应享有的权利。我们会通过在极兔网站发出更新版本并在生效前通过适当方式提醒您相关内容的更新，也请您访问极兔以便及时了解最新的隐私政策。</p>
    <p>2、对于重大变更，我们还会提供更为显著的通知（我们会通过包括但不限于邮件、短信或在浏览页面做特别提示等方式，说明隐私政策的具体变更内容）。本政策所指的重大变更包括但不限于：</p>
    <p>（1）我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；</p>
    <p>（2）我们在所有权结构、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有者变更等；</p>
    <p>（3）个人信息共享、转让或公开披露的主要对象发生变化；</p>
    <p>（4）您参与个人信息处理方面的权利及其行使方式发生重大变化；</p>
    <p>（5）我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时；</p>
    <p>（6）个人信息安全影响评估报告表明存在高风险时。</p>

    <p class="text-bold">九、如何联系我们</p>
    <p>1、如您对本隐私政策或您个人信息的相关事宜有任何问题、意见或建议，请通过访问极兔在线客服系统或拨打我们的官网客服电话400-820-1666等多种方式与我们联系。</p>
    <p>2、一般情况下，我们将在<span class="bg-yellow">三十天内回复</span>。如果您对我们的回复不满意，特别是我们的个人信息处理行为损害了您的合法权益，您还可以向网信、电信、公安及工商等监管部门进行投诉或举报。</p>
  </div>
</template>

<script>
export default {
  name: "PrivacyPolicy",
  data() {
    return {};
  },
  components: {},
};
</script>

<style lang="scss" rel="text/css" scoped>
.privacy {
  background-color: #ffffff;
  font-size: 1em;
  font-weight: 400;
  padding: 20px 30px;
  line-height: 2em;
  .title {
    text-align: center;
    font-size: 2em;
    font-weight: bold;
    margin-bottom: 1em;
  }
  .title-sub {
    font-weight: bold;
    font-size: 1.5em;
    text-align: center;
  }
  .indent {
    text-indent: 2em;
  }
  .text-bold {
    font-weight: bold;
  }
  .bg-yellow {
    background-color: rgb(241, 221, 41);
  }
}
</style>
